import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface PriceItemProps {
    label: string
    price: string
}

const PriceItem: FC<PriceItemProps> = ({ label, price }) => {
    return (
        <View style={styles.container}>
            <Typography.Description size="small" numberOfLines={1} style={styles.label}>
                {label}
            </Typography.Description>
            <Typography.Description
                size="small"
                font="regular"
                numberOfLines={1}
                style={styles.priceText}
            >
                {price}
            </Typography.Description>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        maxWidth: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 12,
    },
    label: {
        color: ColorEnum.GRAY_600,
        flexShrink: 1,
    },
    priceText: {
        color: ColorEnum.GRAY_600,
        flexShrink: 1,
        textAlign: 'right',
    },
})

export default PriceItem
